export const checkIfCurrentIcon = (currentPage: string, currentLinkIcon: string, key: string) => {
    const is_current_icon = currentPage === currentLinkIcon
    if (is_current_icon) {
        return {className: 'active', selectedIndex: parseInt(key)}
    }
    return {}
}